import PropTypes from 'prop-types'
import React from 'react'
import CDropdown from '../dropdown/customDropdown'
import styles from './header.module.scss'
import logoDark from '../../sm-assets/HikeSports-logo.png'
import { formatInternalURL, formatURL } from '../../sm-constants/allNavBars'
import { ONE_TURF_BASE_URL } from '../../sm-constants'

export default function CommonHeader({ InternalRouting, data, allSports, rightSideSection, firstParam, logoSection, Container, CustomLink, pageRouterComp }) {
  const CustomContainer = Container || 'div'
  const baseUrl = ONE_TURF_BASE_URL
  const isActive = (slug) => {
    return slug.length > 1 ? firstParam === formatURL(slug) : firstParam === '/' ||
      firstParam.startsWith('/cricket') ||
      firstParam === '/icc-rankings' ||
      firstParam.includes('cricket')
  }
  return (
    <CustomContainer>
      <div className={`${styles.navbar} ${styles.commonHeader}`}>
        <div className={styles.logoContainer}>
        {logoSection(logoDark)}
        </div>
        <div className={styles.menuContainer}>
          {[...data, ...(allSports?.slice(0, 2) || [])]?.map((d, i) => {
            return (
              <div key={i} className={`${isActive(d?.sSlug) ? styles.active : ''
                } ${styles.mobileLink}`}>
                <div>
                  {pageRouterComp ? (
                    d?.isNotInternal ? <a href={`${baseUrl.slice(0, -1)}${formatURL(d?.sSlug)}`} className={`${styles.menuItem} ${d?.sSlug === firstParam && 'font-bold'}`}>
                      {d?.sTitle}
                    </a> : <CustomLink href={formatInternalURL(d?.sSlug)}>
                      <a className={`${styles.menuItem} ${d?.sSlug === firstParam && styles.selectedLink}`}>{d?.sTitle}</a>
                    </CustomLink>
                  ) : (
                    <a href={`${baseUrl.slice(0, -1)}${formatURL(d?.sSlug)}`} className={`${styles.menuItem} ${d?.sSlug === firstParam && 'font-bold'}`}>
                      {d?.sTitle}
                    </a>
                  )}
                </div>
                <div
                  className={`${isActive(d?.sSlug) ? styles.selectedTriangle : ''
                    } ${styles.absolute}`}>
                      <div className={styles.triangleSlide}>
                        </div>
                    </div>
              </div>
            )
          })}
          {allSports.length ? (
            <CDropdown
              InternalRouting={InternalRouting}
              CustomLink={CustomLink}
              data={{
                sTitle: (
                  <span className={`${styles.menuItem} ${styles.more}`} style={{ marginInline: '0px' }}>
                    <HamburgerIcon />
                  </span>
                ),
                oChildren: allSports.slice(2, allSports?.length) || [],
                _id: 'sports-selection-desk'
              }}
              pageRouterComp={pageRouterComp}
              baseUrl={baseUrl}
            />
          ) : null}
        </div>

        {rightSideSection && <>{rightSideSection}</>}
      </div>
    </CustomContainer>
  )
}
CommonHeader.propTypes = {
  InternalRouting: PropTypes.bool,
  data: PropTypes.array,
  allSports: PropTypes.array,
  rightSideSection: PropTypes.any,
  CustomLink: PropTypes.any,
  logoSection: PropTypes.func,
  Container: PropTypes.any,
  firstParam: PropTypes.string,
  pageRouterComp: PropTypes.bool
}

function HamburgerIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18" fill="none">
      <path d="M22 2H2" stroke="#FFF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22 9H2" stroke="#FFF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22 16H2" stroke="#FFF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
